import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA
} from '@angular/material/bottom-sheet';

@Component({
  templateUrl: './variable-list.component.html',
  styleUrls: ['./variable-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableListComponent implements OnInit {
  releaseVariableKeys: any[];
  licenseVariableKeys: any[];

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<VariableListComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {
    this.releaseVariableKeys = Object.keys(data.releaseVariables);
    this.licenseVariableKeys = Object.keys(data.licenseVariables);
  }

  ngOnInit() {}

  dismiss(): void {
    this._bottomSheetRef.dismiss();
  }
}
